/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import ItemTypes from '../../constants/itemTypes';

const fileTarget = {
  drop(props, monitor, component) {
    if (props.onDrop && component.props.allowCreateAttachment) {
      props.onDrop(props, monitor);
    }
  }
};

function collectTarget(connector, monitor) {
  return {
    connectDropTarget: connector.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
}

class FileDropBox extends React.Component {
  constructor(props) {
    super(props);
    this.fileUploader = React.createRef();
  }

  triggerFileUpload = event => {
    event.preventDefault();
    if (this.props.allowCreateAttachment) this.fileUploader.current.click();
  };

  render() {
    const { canDrop, isOver, connectDropTarget, clear } = this.props;
    const isActive = canDrop && isOver && this.props.allowCreateAttachment;

    return connectDropTarget(
      <div className="dropbox-container">
        <div
          id="attachments"
          className={`file-drop ${isActive ? 'active-file-drop' : ''} ${
            clear ? 'clear' : ''
          }`}
          onClick={this.triggerFileUpload}
        >
          Drag and drop a file here or click here to attach a file to this item
        </div>
        <input
          ref={this.fileUploader}
          type="file"
          onChange={this.props.onUpload}
          style={{ display: 'none' }}
          multiple
        />
      </div>
    );
  }
}

FileDropBox.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired,
  allowCreateAttachment: PropTypes.bool.isRequired,
  onDrop: PropTypes.func,
  onUpload: PropTypes.func
};

export default DropTarget(
  ItemTypes.FILE,
  fileTarget,
  collectTarget
)(FileDropBox);
